<template>
  <Collapsible v-model="localValue" @opened="$emit('opened')" @closed="$emit('closed')">
    <template #trigger="{ isOpen, toggle }">
      <div
        class="w-full flex flex-row items-center justify-between gap-2 p-[16px] md:p-[20px] lg:p-[24px] cursor-pointer"
        :class="isOpen ? 'bg-[#ECEBEB]' : 'bg-[#F6F4F0]'"
        @click="isEmpty() ? '' : toggle()"
      >
        <div
          class="w-full flex flex-row justify-between text-[1rem] md:text-[1.125rem] lg:text-[1.25rem] leading-[1.375rem] md:leading-[1.5rem] lg:leading-[1.625rem] text-[#21201E]"
        >
          <div class="font-medium">{{ title }}</div>
          <div class="font-bold" :class="{ 'pr-[24px]': isEmpty() }">
            {{ totalAmountFulfilled }}
          </div>
        </div>
        <img
          v-if="!isEmpty()"
          src="/assets/icons/chevron-down.svg"
          alt=""
          class="w-[16px] h-[16px] md:w-[20px] md:h-[20px] lg:w-[24px] lg:h-[24px]"
          :class="[
            'theme-accordian-icon',
            'transition-transform duration-300 ease-in-out',
            isOpen ? 'rotate-0' : 'rotate-[-90deg]',
          ]"
        />
      </div>
    </template>
    <template #collapsible="{ isOpen }">
      <div
        v-show="isOpen"
        class="w-full flex flex-col gap-3 text-[0.875rem] md:text-[1rem] lg:text-[1.125rem] leading-[1.25rem] md:leading-[1.375rem] lg:leading-[1.5rem] font-medium text-[#373531] bg-[#ECEBEB] pb-[12px] md:pb-[16px] lg:pb-[20px] pl-[16px] md:pl-[20px] lg:pl-[24px] pr-[40px] md:pr-[48px] lg:pr-[56px]"
      >
        <div v-for="(value, index) in tableData" :key="index">
          <div class="w-full flex flex-row justify-between">
            <div>
              {{ formatDate(value.giving_date) }}
            </div>
            <div>{{ formatMonthlyFulfilledAmount(Number(value.amount)) }}</div>
          </div>
        </div>
      </div>
    </template>
  </Collapsible>
</template>

<script>
import Collapsible from '@/components/design/Collapsible';
import HasLocalValue from '@/mixins/HasLocalValue';
import { formatDate } from '@/utils/formatDateToTime';

export default {
  components: {
    Collapsible,
  },

  mixins: [HasLocalValue],

  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    additionalCollapseClass: {
      type: String,
      default: '',
    },
    initialOpen: {
      type: Boolean,
      default: true,
    },
    tableData: {
      type: Object,
      required: true,
    },
    selectedYear: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      localValue: false,
    };
  },
  computed: {
    totalAmountFulfilled() {
      // sum of amount field in each element in tableData
      const amount = this.tableData?.reduce((sum, element) => sum + Number(element.amount), 0) ?? 0;
      return `$${amount?.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`;
    },
  },
  methods: {
    isEmpty() {
      return this.tableData?.length < 1;
    },
    formatDate(date) {
      const dateObj = new Date(date);
      const dayString = dateObj.toLocaleString('en-US', {
        day: '2-digit',
      });
      const monthString = dateObj.toLocaleString('en-US', {
        month: 'short',
      });
      const yearString = dateObj.toLocaleString('en-US', {
        year: 'numeric',
      });

      return dayString + ' ' + monthString + ' ' + yearString;
    },
    formatMonthlyFulfilledAmount(amount) {
      return `$${amount?.toLocaleString('en-US', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`;
    },
  },
};
</script>
